import styled from 'styled-components'

import { ArrowDirectionIcon as ArrowDirectionIconBase } from '@application/Interfaces/Icons'

export const ProfileContainer = styled.div`
    background-color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.boxShadow.level2};
    padding: 16px;
    border-radius: 10px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 0;
    }
`

export const ProfileHeaderSection = styled.div``

export const ProfileTitle = styled.div`
    color: ${(props) => props.theme.color.a500};
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.bold};
    text-transform: uppercase;
`

export const ProfileContent = styled.div`
    padding-top: 8px;
`

export const QuestionLabel = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.black};
    margin-bottom: 14px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
        margin-bottom: 16px;
    }
`

export const IconWrapper = styled.div`
    height: 57px;
    width: 57px;
    border-radius: 57px;
    background-color: ${(props) => props.theme.color.p100};
    margin-right: 8px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        display: none;
    }
`

export const Option = styled.a`
    display: block;
    border: 1px solid ${(props) => props.theme.color.g200};
    border-radius: 10px;
    padding: 10px 15px;
    margin-bottom: 16px;
    text-decoration: none;
    display: flex;
    align-items: center;

    &:hover,
    &:active {
        ${(props) => props.theme.boxShadow.level2};
    }

    &:hover {
        ${IconWrapper} {
            svg {
                display: none;
            }

            img {
                display: block;
            }
        }
    }
`

export const TextWrapper = styled.div`
    flex: 1;
    margin-right: 8px;
`

export const OptionTitle = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};
`
export const ArrowDirectionIcon = styled(ArrowDirectionIconBase)`
    flex-shrink: 0;
`

export const OptionDescription = styled.div`
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
`

export const StudentOption = styled.div`
    text-align: center;
`
